import {Injectable} from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';
import {Observable} from "rxjs/Rx";

@Injectable()
export class NeoConfigStepsService {

    constructor(
        private _rest: NeoRestService
    ) {}

    /**
     * Crea una configuración para unos steps
     *
     * @param site
     * @param body
     */
    createConfigSteps(site, body): Observable<any> {
        return this._rest.post(`/configsteps/${site}`, body);
    }

    /**
     * Actualiza una configuración para unos steps
     *
     * @param site
     * @param body
     */
    updateConfigSteps(site, body): Observable<any> {
        return this._rest.putRaw(`/configsteps/${site}`, body);
    }

    /**
     * Elimina una configuración para unos steps
     *
     * @param site
     */
    deleteConfigSteps(site): Observable<any> {
        return this._rest.delete(`/configsteps/${site}`);
    }

    /**
     * Obtiene las configuraciónes de steps
     */
    getConfigsSteps(): Observable<any> {
        return this._rest.get(`/configsteps`);
    }

    /**
     * Obtiene la configuración de un steps
     *
     * @param site
     */
    getConfigSteps(site): Observable<any> {
        return this._rest.get(`/configsteps/${site}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-configsteps/neo-configsteps.service.ts